import React, { useEffect, useState } from "react";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  DateTimePicker,
  DateTimeValidationError,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { DateTime } from "luxon";
import { FormField } from "components/shared-ui/form/form-field/form-field";
import { FormFieldError } from "components/shared-ui/form/form-field-error/form-field-error";

export interface IDatePickerProps {
  value: any;
  onChange: (value: DateTime) => void;
  onError: (message?: string) => void;
}

export function DatePicker(props: IDatePickerProps) {
  const [message, setMessage] = useState<string | null>();

  const onError = (error: DateTimeValidationError, value: DateTime) => {
    if (error === "maxTime" || error === "maxDate") {
      const message = `selected value ${value.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)} is a future date`;
      setMessage(message);
    } else {
      setMessage(null);
    }
  };

  useEffect(() => {
    props.onError(message);
  }, [message]);
  return (
    <FormField testId="date-time-picker" visible={true}>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <DateTimePicker
          orientation="portrait"
          disableFuture
          maxDateTime={DateTime.now()}
          ampmInClock
          value={props.value}
          onChange={props.onChange}
          views={["year", "month", "day", "hours", "minutes", "seconds"]}
          // displayStaticWrapperAs="desktop"
          onError={onError}
          slotProps={{
            toolbar: {
              hidden: false,
            },
            actionBar: {
              actions: [],
            },
          }}
          viewRenderers={{
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
            seconds: renderTimeViewClock,
          }}
        />
      </LocalizationProvider>
      <FormFieldError error={message} />
    </FormField>
  );
}
